<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span> <em name="Exhibition"></em>
          <span>/</span>Hardcopy Invitation
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>

    <div class="MbDevice">
      <div class="homeLeft mt-5">
        <div class="UserAccount ml-1">
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
        <hr />
        <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition"></p>
          <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
          <p>{{ eExhVenue }}</p>
        </div>
        <p class="clear"></p>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div class="articleEn">
      <div>
        <div class="PcDevice">
          <div class="contentBoxStatus py-3">
            <div class="d-flex align-items-center justify-content-around">
              <div
                v-for="(item, index) in MenuInvitation"
                :key="index"
                class="btn btn-white py-2 px-4"
                style="border-radius: 20px; border-color: #d9d9d9"
                @click="InviteLink(item.Url)"
              >
                <span
                  class="font-weight-bold text-primary"
                  style="font-size: 16px"
                  v-if="item.MenuName == 'Hardcopy Invitation'"
                >
                  <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                </span>
                <span v-else> <i class="fas fa-caret-right"></i> {{ item.MenuName }} </span>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
        </div>
        <div class="contentBox">
          <!-- left -->
          <div class="proLeft NoShowInMobile align_c">
            <img src="@/assets/images/iconPaper.svg" width="100%" />
          </div>
          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <div class="MbDevice">
              <div class="d-flex justify-content-between align-items-center">
                <!-- <div>
                  <h1><img src="@/assets/images/iconInvite.svg" width="35px" class="mb-2" /> Hardcopy Invitation</h1>
                
                
                </div> -->

                <div class="d-flex align-items-center">
                  <div>
                    <img src="@/assets/images/iconPaper.svg" width="35px" class="mt-1 mr-1" />
                  </div>
                  <div>
                    <h1>Hardcopy Invitation</h1>
                  </div>
                </div>
                <div class="mb-2">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <span class="border py-1 px-3">
                        <i class="fas fa-ellipsis-h"></i>
                      </span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item, index) in MenuInvitation" :key="index">
                        <span class="MbListGray" @click="InviteLink(item.Url)"> {{ item.MenuName }} </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <div class="PcDevice">
              <h1>Hardcopy Invitation</h1>
            </div>
            <p class="my-3">&nbsp;</p>
            In order to respond to environmental protection policies, invitations for guests are mainly digitalization.
            If necessary, you can also apply for a hardcopy invitation and provide it to your customers by mail or in
            person. Invited Guests must follow the instructions and complete the ticket redemption. During the
            exhibition period, they can use the “Admission QR Code”for admission.

            <p class="my-3">&nbsp;</p>
            <!-- <ol class="number">
              <li>
                Please request before <span class="red"><span name="CloseDay"></span> 23:59</span>, late application
                will not be accepted.
              </li>
              <li>Within 250 invitations: Free of charge</li>
              <li>
                More than 251 invitations: The excess printing shall be printed by the exhibitor at their own expense
              </li>
              <li>This hardcopy invitation is not eligible for direct admission</li>
            </ol> -->

            <div v-if="!hasAccountId">
              <p class="my-3">&nbsp;</p>
              <div class="alert alert-danger" role="alert">
                <img src="@/assets/images/tickGray.svg" width="16px" class="mb-1 mr-1" alt="" />
                The process of your code application is not successful, and please reach the contact of exhibition for
                further actions.
              </div>
              <h3 class="mt-4 mb-3">Contact</h3>
              <div name="ExpoContact"></div>
            </div>

            <div v-else>
              <p class="lightLine">&nbsp;</p>
              <h3>Investigation</h3>
              <p class="my-3">&nbsp;</p>
              <li>
                Please request before <span class="red"><span name="CloseDay"></span> 23:59</span>, late application
                will not be accepted.
              </li>
              <li>
                This hardcopy invitation does not equal for admission, visitors must complete the online ticket
                redemption to receive “Admission QR Code”for admission.
              </li>
              <div class="grayBG mt-3" v-if="hasApply">
                Apply for Hardcopy Invitation：<span style="text-decoration: underline" v-if="InvQty == 1">Yes</span
                ><span style="text-decoration: underline" v-else>No</span>

                <div class="mt-2">
                  Last updated：<span style="text-decoration: underline">{{ UpdateTime }}</span>
                </div>
              </div>
              <p class="my-3">&nbsp;</p>
              <a
                :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/invitePaperApply?no=${RegNo}`"
                data-fancybox
                data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                data-type="iframe"
                class="btnStyle iframeForm AddRegLink linkstyle"
                v-if="!hasApply"
                >Reply</a
              >

              <a
                :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/invitePaperApply?no=${RegNo}`"
                data-fancybox
                data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                data-type="iframe"
                class="btnStyle iframeForm AddRegLink linkstyle"
                v-if="hasApply"
                >Edit
              </a>

              <p class="mt-5" v-if="InvitationSampleImg">
                <img
                  :src="`https://www.chanchao.com.tw/ExhibitionFiles/hardcopyInvitation/${InvitationSampleImg}`"
                  width="400px"
                  alt=""
                  class="img-fluid"
                />
              </p>
              <p class="lightLine">&nbsp;</p>
              <h3>Contact</h3>
              <p class="my-3">&nbsp;</p>
              <div name="ExpoContact"></div>
            </div>
          </div>
          <p class="clear"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: `Hardcopy invitation - Chan Chao Exhibitor's Online Service System`,
      }
    },

    data() {
      return {
        UserId: '',
        RegNo: '',
        CSRF_Token: '',
        InvitationQty: '',
        InvitationCompanyName: '',
        InvCode: '',
        lang: 'en',
        InvitationSampleImg: '',
        hasAccountId: true,
        MenuInvitation: [],
        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
        hasApply: false,
        InvQty: '',
        UpdateTime: '',
      }
    },
    methods: {
      InviteLink(Url) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`
        }
      },

      closefancybox() {
        parent.$.fancybox.close()
      },
    },

    created() {
      const vm = this

      //取得語系

      let lang = 'en'

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1]

      //取得既有資料

      let url = `/apiExhibitors/HardcopyInvitation/${vm.RegNo}?lang=${vm.lang}`

      axios.get(url).then((response) => {
        // console.log(response)
        if (response.data.Code == 200) {
          vm.InvQty = response.data.Data.InvQty
          vm.InvCode = response.data.Data.InvCode
          vm.hasApply = true
          vm.UpdateTime = response.data.Data.UpdateTime
        } else if (response.data.Code == 404) {
          vm.hasApply = false
        }
      })

      //取得參展商總資訊
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`).then((response) => {
        // console.log(response)
        vm.InvitationSampleImg = response.data.Data.InvitationSample

        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue
      })

      //判斷是否有AccountID
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
        // console.log(response.data.Data)

        let AccountID = response.data.Data.AccountID

        if (!AccountID) {
          vm.hasAccountId = false

          $.getJSON('/apiExhibitors/ExpoContact/' + RegNo + '?lang=' + lang, function (data) {
            $('[name="ExpoContact"]').html(data.Data.ExpoContact)
          })
        } else {
          vm.hasAccountId = true
        }
      })

      //取得邀請選單
      axios
        .get(`https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`)
        .then((response) => {
          // console.log(response.data.Data)

          vm.MenuInvitation = response.data.Data
        })

      $.getJSON('/apiExhibitors/Exhibition/' + vm.RegNo, { lang: lang }, function (data) {
        //get close day
        //var CloseDay = new Date(data.ExhBegin)
        //CloseDay.setDate(CloseDay.getDate() - 70)
        //改抓API的deadline
        var CurrentDate = new Date()
        var ShowCloseDay = new Date(data.Data.HardcopyInvDeadLine)
        var SystemCloseDay = new Date(data.Data.HardcopyInvDeadLine)

        $('[name="CloseDay"]').text(formatDate(ShowCloseDay))
        function formatDate(date) {
          var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()
          if (month.length < 2) month = '0' + month
          if (day.length < 2) day = '0' + day
          return [year, month, day].join('/')
        }

        SystemCloseDay.setDate(ShowCloseDay.getDate() + 1)

        if (CurrentDate > SystemCloseDay) {
          if (lang == 'tw') {
            $('.btnStyle').addClass('btnExpire')
          } else {
            $('.btnStyle').addClass('ebtnExpire')
          }
        }

        //get contact info
        $.getJSON('/apiExhibitors/ExpoContact/' + vm.RegNo + '?lang=' + lang, function (data) {
          $('[name="ExpoContact"]').html(data.Data.ExpoContact)
        })
      })
    },
  }
</script>

<style lang="scss">
  .linkstyle:hover {
    color: #ffffff;
  }

  .alert-danger {
    background-color: #f8d7da;
  }

  .alert {
    padding: 10px 10px;
    font-size: 15px;
  }
</style>
